import { useContext, useState } from 'react';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { LOCAL_STORAGE_KEYS, STORAGE_TYPES } from 'common/constants/constants';
import FilterSetForm from '../../FilterSet/FilterSetForm';
import useEventsTracker from '../../tracking/useEventsTracker';
import useContextActions from '../../../../useContextActions';

const storageAccessor = BrowserStorageAccessor()[STORAGE_TYPES.LOCAL];

const useSaveFilterSetCTA = ({ Context, onClose }) => {
  const {
    modalHandler,
    state: { localFilters }
  } = useContext(Context);
  const contextActions = useContextActions({ Context });
  const eventsTracker = useEventsTracker({ Context });
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const updateDontShowAgainOnStorage = () =>
    storageAccessor.set(
      LOCAL_STORAGE_KEYS.DONT_SHOW_FILTER_SET_CTA,
      dontShowAgain
    );

  const onApplyWithoutSaving = () => {
    updateDontShowAgainOnStorage();
    eventsTracker.applyFiltersCTA.applyWithoutSaving(dontShowAgain);
    contextActions.onChangeFilters(localFilters);
    onClose();
  };
  const onProccedToSave = () => {
    updateDontShowAgainOnStorage();
    eventsTracker.applyFiltersCTA.proceedToSave(dontShowAgain);
    modalHandler.openModal({
      content: () => (
        <FilterSetForm Context={Context} onSubmit={modalHandler.closeModal} />
      ),
      stickToTop: true
    });
  };

  return {
    dontShowAgain,
    setDontShowAgain,
    onApplyWithoutSaving,
    onProccedToSave
  };
};

export default useSaveFilterSetCTA;
